import React from "react";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function User({ resource }: Props) {
  return (
    <div className={styles.resource}>
      <div className={styles.user}>
        <div className={styles.avatar}>
          <ResourceAvatar resource={resource} />
        </div>
        <div>
          <p className={styles.name}>{resource.name}</p>
        </div>
      </div>
    </div>
  );
}

export { User };
